import React from 'react';

export const ContactUs = () => (
    <div
        data-testid="contact-us"
        style={{
            maxWidth: '90%',
            margin: '0 auto',
            padding: '2rem',
            fontFamily: 'Roboto',
            fontWeight: 400,
            fontSize: 15,
            lineHeight: '160%',
            letterSpacing: 0,
            color: '#4C525D',
        }}
    >
        <h1
            style={{
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: 35,
                lineHeight: '56px',
                letterSpacing: 0,
                color: '#071424',
                padding: '16px 0',
            }}
        >
            Contact Us
        </h1>
        <p>
            If you would like to purchase a printed version of a Subaru document (Owners Manual, Service Manual, etc.),
            please call <strong>1-866-428-2278</strong> and speak to a customer service representative. All other
            inquiries must be directed to the contact methods below.
        </p>
        <hr />
        <p>
            If you would like to speak to a Subaru representative, please check the hours of operation and call a
            Customer Service number, below.
        </p>
        <p>
            For Subaru Owners and Non-Subaru Personnel: Customer Service:{' '}
            <strong>1-800-SUBARU3 (1-800-782-2783)</strong>
        </p>
        <p>
            For Subaru Personnel and Subaru Retailers: SOA Help Desk: <strong>1-800-SOA-STAR (1-800-762-7827)</strong>
        </p>
        <hr />
        <div style={{ display: 'flex', gap: '2rem', marginTop: '2rem' }}>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', margin: 0, flex: 1 }}>
                <strong>Hours of Operation:</strong>
                <li>7:30 a.m. - 8:00 p.m. (EST) Monday through Thursday</li>
                <li>10:30 a.m. - 5:00 p.m. (EST) Friday</li>
                <li>9:00 a.m. - 3:30 p.m. (EST) Saturday</li>
            </ul>
            <ul style={{ listStyle: 'disc', paddingLeft: '2rem', margin: 0, flex: 1 }}>
                <strong>Subaru of America, Inc.</strong>
                <li>Customer Advocacy Department</li>
                <li>One Subaru Drive</li>
                <li>PO Box 9103</li>
                <li>Camden, NJ 08101-9877</li>
            </ul>
        </div>
    </div>
);
